"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Icon } from "@/components/formatters/MXPIcon";
import { SpecialButton } from "../../component/SpecialButton/SpecialButton";
import { CommonDescription } from "../CommonDescription/CommonDescription";
import { RichTextRenderer } from "../../utils/RichTextRenderer";
import { useAccordionGroup } from "./AccordionGroupContext";
export type AccordionProps = {
  headline: string;
  description: any;
  ctaLink?: {
    label: string;
    destination: string;
  };
  className?: string;
  isOpen?: boolean | undefined | null;
  onToggle?: (isOpen: boolean) => void;
  groupItemId?: string;
};
const TITLE_HEADLINE = ["text-xl font-bold leading-relaxed max-w-[747px]", "max-lg:leading-snug max-lg:font-semibold max-lg:max-w-[560px] max-lg:m-0", "max-md:text-lg max-md:max-w-[400px]", "max-sm:text-base max-sm:max-w-[280px]", "t2-dark:text-white"].join(" ");
const TOGGLE_BTN = ["flex justify-center items-center w-[50px] h-[50px] text-gray-m9 border border-gray-m9 rounded-full bg-white cursor-pointer", "max-[600px]:w-10 max-[600px]:h-10"].join(" ");
const CONTENT_BASE = ["text-2xl font-normal leading-9 max-h-0 overflow-hidden transition-[max-height,padding] duration-300 ease-in-out", "max-lg:text-xl max-lg:leading-8", "max-md:text-lg max-md:leading-7", "max-sm:text-base max-sm:leading-snug max-sm:font-light", "[&_.t2-accordion-content--description]:max-w-[747px] [&_.t2-accordion-content--description]:mb-[26px]", "[&_.t2-accordion-content__image]:my-4 [&_.t2-accordion-content__image_img]:h-auto [&_.t2-accordion-content__image_img]:max-w-full [&_.t2-accordion-content__image_img]:object-contain"].join(" ");
export const Accordion = t0 => {
  const $ = _c(55);
  const {
    headline,
    description,
    ctaLink,
    className: t1,
    isOpen: t2,
    onToggle: t3,
    groupItemId
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const isOpenProp = t2 === undefined ? false : t2;
  const onToggleProp = t3 === undefined ? _temp : t3;
  const group = useAccordionGroup();
  const registerItem = group?.registerItem;
  let t4;
  if ($[0] !== groupItemId || $[1] !== headline) {
    t4 = groupItemId || `accordion-item-${(headline ?? "").replace(/\s+/g, "-").toLowerCase()}`;
    $[0] = groupItemId;
    $[1] = headline;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const itemId = t4;
  let t5;
  let t6;
  if ($[3] !== itemId || $[4] !== registerItem) {
    t5 = () => {
      if (registerItem) {
        return registerItem(itemId);
      }
    };
    t6 = [registerItem, itemId];
    $[3] = itemId;
    $[4] = registerItem;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useLayoutEffect(t5, t6);
  const [localOpen, setLocalOpen] = useState(isOpenProp || false);
  let t7;
  if ($[7] !== group || $[8] !== isOpenProp || $[9] !== localOpen) {
    t7 = () => {
      if (!group && isOpenProp !== localOpen && typeof isOpenProp === "boolean") {
        setLocalOpen(isOpenProp);
      }
    };
    $[7] = group;
    $[8] = isOpenProp;
    $[9] = localOpen;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isOpenProp) {
    t8 = [isOpenProp];
    $[11] = isOpenProp;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t9;
  if ($[13] !== group || $[14] !== itemId || $[15] !== localOpen) {
    t9 = group ? group.isItemOpen(itemId) : localOpen;
    $[13] = group;
    $[14] = itemId;
    $[15] = localOpen;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const isOpen = t9;
  let t10;
  if ($[17] !== group || $[18] !== itemId || $[19] !== localOpen || $[20] !== onToggleProp) {
    t10 = () => {
      if (group) {
        group.toggleItem(itemId);
      } else {
        setLocalOpen(!localOpen);
        onToggleProp(localOpen);
      }
    };
    $[17] = group;
    $[18] = itemId;
    $[19] = localOpen;
    $[20] = onToggleProp;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const onToggle = t10;
  const openClasses = isOpen ? "bg-gray-m1 border-dashed !border-gray-m3 !border-t t2-dark:bg-gray-m10 t2-dark:!border-gray-m7" : "";
  const t11 = `border-b border-gray-m2 py-8 px-5 md:py-10 md:px-16 lg:px-10 xl:px-10 ${openClasses} ${className}`;
  const t12 = `${itemId}-content`;
  let t13;
  if ($[22] !== onToggle) {
    t13 = e => {
      if (e.key === "Enter" || e.key === " ") {
        onToggle();
      }
    };
    $[22] = onToggle;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== headline) {
    t14 = <h3 className={TITLE_HEADLINE}>{headline}</h3>;
    $[24] = headline;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = `${TOGGLE_BTN} ${isOpen ? "bg-yellow-m10 border-0" : ""}`;
  const t16 = isOpen ? `Collapse ${headline}` : `Expand ${headline}`;
  let t17;
  if ($[26] !== isOpen) {
    t17 = isOpen && <Icon type="t2u-collapse-open" size={18} />;
    $[26] = isOpen;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== isOpen) {
    t18 = !isOpen && <Icon type="t2u-collapse-close" size={18} />;
    $[28] = isOpen;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t15 || $[31] !== t16 || $[32] !== t17 || $[33] !== t18) {
    t19 = <span className={t15} aria-label={t16}>{t17}{t18}</span>;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== isOpen || $[36] !== onToggle || $[37] !== t12 || $[38] !== t13 || $[39] !== t14 || $[40] !== t19) {
    t20 = <div className="t2-accordion__toggle cursor-pointer flex justify-between items-center max-[600px]:items-start max-[600px]:mb-3" onClick={onToggle} aria-expanded={isOpen} aria-controls={t12} role="button" tabIndex={0} onKeyDown={t13}>{t14}{t19}</div>;
    $[35] = isOpen;
    $[36] = onToggle;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  const t21 = `${CONTENT_BASE} ${isOpen ? "max-h-[1000px]" : ""}`;
  const t22 = `${itemId}-content`;
  let t23;
  if ($[42] !== description) {
    t23 = description && <CommonDescription description={description?.props?.data?.content ? <RichTextRenderer raw={description.props.data.content.raw} references={description.props.data.content.references} componentClass="t2-accordion-content" /> : description} className="t2-accordion-content__description t2-layout__description richtxt" />;
    $[42] = description;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== ctaLink) {
    t24 = ctaLink && <SpecialButton label={ctaLink.label} destination={ctaLink.destination} primary={false} />;
    $[44] = ctaLink;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t21 || $[47] !== t22 || $[48] !== t23 || $[49] !== t24) {
    t25 = <div className={t21} id={t22}>{t23}{t24}</div>;
    $[46] = t21;
    $[47] = t22;
    $[48] = t23;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t11 || $[52] !== t20 || $[53] !== t25) {
    t26 = <div className={t11}>{t20}{t25}</div>;
    $[51] = t11;
    $[52] = t20;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  return t26;
};
function _temp() {}